import { Alert } from 'antd';
import { useAuthSession } from '@/entities/auth/api/hooks';
import { PageSpinner } from '@/shared/ui/PageSpinner';
import { SizTab as EmployeeSizTab } from '@/pages/Employees/EmployeeCard/SizTab';

/**
 * Подраздел `my_ppe` (GET /v1/ppe/sections, US-6.4.2).
 *
 * Берёт `employee_id` из текущей сессии и переиспользует экран
 * `SizTab` карточки сотрудника (нормы, выдачи, история).
 */
export function MyPpeTab() {
  const { data: auth, isLoading } = useAuthSession();

  if (isLoading) return <PageSpinner />;

  const employeeId = auth?.user.employee_id;

  if (!employeeId) {
    return (
      <Alert
        type="info"
        showIcon
        message="Учётная запись не привязана к сотруднику"
        description="Обратитесь к администратору, чтобы привязать вашу учётную запись к карточке сотрудника."
      />
    );
  }

  return <EmployeeSizTab employeeId={employeeId} />;
}
